// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3vADa","inlineContent":"_1SxmE","pageWrapper":"u_ovd","root":"_2XbCD"};